"use client";
import { useEffect, useLayoutEffect, useState } from "react";

function usePersistentState<T>(
  storageKey: string,
  defaultValue: T
): [T, React.Dispatch<React.SetStateAction<T>>] {
  const [state, setState] = useState<T>(() => {
    try {
      if (typeof window === "undefined") return defaultValue;
      const storedValue = localStorage.getItem(storageKey);
      if (storedValue) {
        return JSON.parse(storedValue);
      }
      return defaultValue;
    } catch (e) {
      return defaultValue;
    }
  });

  useEffect(() => {

    localStorage.setItem(storageKey,state === undefined ? '' :  JSON.stringify(state));
  }, [state, storageKey]);

  return [state, setState];
}


const memoryCache = new Map();

export function useInMemoryState<T>(storageKey: string, defaultValue: T): [T, React.Dispatch<React.SetStateAction<T>>] {
  const [state, setState] = useState<T>(() => {
    try {
      const storedValue = memoryCache.get(storageKey);
      return storedValue || defaultValue;
    } catch (e) {
      return defaultValue;
    }
  });

  useEffect(() => {

    memoryCache.set(storageKey,state);
  }, [state, storageKey]);

  return [state, setState];
}


export default usePersistentState;
